// import PropTypes from 'prop-types'
import React, {useEffect} from 'react'
// import ScrollAnim from 'rc-scroll-anim'
import {Controller, Scene} from 'react-scrollmagic'
import {Tween} from 'react-gsap'
// import {useDispatch, useSelector} from 'react-redux'
// import {RootState} from 'store'
import styled, {css} from 'styled-components'
import ShanShui from '../../assets/images/OurStory_ShanShui.png'
import ShanShuiTop from '../../assets/images/OurStory_Top_Sm.png'
import ShanShuiBottom from '../../assets/images/OurStory_Bottom_Sm.png'
import SpiritualInspirationTitle from '../../assets/images/SpiritualInspirationTitle.svg'
import IndependentTitle from '../../assets/images/IndependentTitle.svg'
import Breakpoint from '../../utils/breakpoint'
import Font from '../../utils/Font'
import {Box, BoxTitle} from './styles'

const {mobile, desk} = Breakpoint
const mdBreakpoint = 1000
interface LabelProps {
  readonly langCode: string
}

const chineseLang = ['zh-tw', 'zh-cn']
const otherLangsMap = [...chineseLang, 'ja']
const frenchMap = ['fr', 'pl', 'pt', 'sv', 'ru', 'id']
const langTextMap = ['vi']

const Container = styled.div<LabelProps>`
  //background-image: url('${ShanShui}');
  font-family: ${({langCode}) => Font(langCode).mainFont};
  min-height: 2000px;
  align-items: center;
  justify-content: center;
  padding-top: 270px;
  padding-bottom: 200px;
  background-position: 50% 100%;
  background-size: 1500px auto;
  background-repeat: no-repeat;
  @media (max-width: ${mobile}px) {
    position: relative;
    width: 100%;
    min-height: 1000px;
    background-position: 50% 95%;
    padding-top: 96vw;
    background-image: url(${ShanShuiBottom}) !important;
    background-size: 100% auto;
    &:before {
      content: '';
      position: absolute;
      top: 17vw;
      left: 0;
      right: 0;
      width: 100%;
      height: 100vw;
      background-image: url(${ShanShuiTop});
      background-size: 100% auto;
      background-repeat: no-repeat;
      z-index: 1;
    }
  }
  @media (min-width: 1200px) {
    width: 100%;
    min-height: 2200px;
    background-position: 50% 285px;
  }
`
const Wrapper = styled.div<LabelProps>`
  display: flex;
  flex-direction: ${({langCode}) => (langCode === 'il' ? 'row-reverse' : 'row')};
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: ${({langCode}) => (frenchMap.indexOf(langCode) > -1 ? '7' : '17')}vw;
  @media (max-width: ${mdBreakpoint}px) {
    display: block;
    padding-left: 15px;
    padding-right: 15px;
  }
`
const Aside = styled.div`
  flex: 0 1 50%;
  @media (max-width: ${mdBreakpoint}px) {
    width: 100%;
    min-height: 2vh;
  }
`
const MainContent = styled.div<LabelProps>`
  flex: ${({langCode}) => (frenchMap.indexOf(langCode) > -1 ? '0 1 50%' : '0 1 40%')};
  @media (max-width: ${mdBreakpoint}px) {
    width: 100%;
    flex: 0 1 100%;
    max-width: 540px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 15px;
    padding-right: 15px;
  }
`
const FigureText = styled.h3`
  padding-bottom: 0;
  margin-bottom: 6px;
`

const Introduction = styled.div<LabelProps>`
  font-family: ${({langCode}) => Font(langCode).mainFont};
  flex: 0 1 60%;
`
const WrapperContent = styled.div<LabelProps>`
  max-width: ${({langCode}) => (otherLangsMap.indexOf(langCode) > -1 ? '550' : (langTextMap.includes(langCode)?'860':'720'))}px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 100px;
  padding-bottom: 115px;
  @media (max-width: ${mobile}px) {
    width: 100%;
    padding-left: 30px;
    padding-right: 30px;
  }
  @media (min-width: ${desk}px) and (max-width: ${mdBreakpoint}px) {
    //max-width: 40vw;
  }
`
const MainContentText = styled.div``

const fullWidthLineLang = ['zh-tw', 'zh-cn', 'ja', 'ko', 'vi', 'pt']
const Label = styled.h2<LabelProps>`
  padding-bottom: 2rem;
  color: #633b1a;
  ${({langCode}) =>
    !fullWidthLineLang.includes(langCode) &&
    css`
      max-width: 200px;
    `}

  ${({langCode}) =>
    langCode === 'fr' &&
    css`
      max-width: 500px;
    `}
`
interface IProps {
  miscData: any
  langCode: string
}

const Independent: React.FC<IProps> = ({miscData, langCode}) => {
  // const content = useSelector((state: RootState) => state.main.contentData)
  // const loading = useSelector((state: RootState) => state.main.loading)
  // const error = useSelector((state: RootState) => state.main.error)
  // const dispatch = useDispatch()
  // useEffect(() => {}, [])
  const isChineseLang = chineseLang.indexOf(langCode) > -1
  return (
    <>
      <div id="trigger" />
      <Controller>
        <Scene triggerElement="#trigger" duration={3300}>
          {(progress: number | undefined) => (
            <Tween
              from={{
                backgroundColor: '#eb912d',
              }}
              to={{
                backgroundColor: '#f8f5ee',
              }}
              ease="power2.out"
              totalProgress={progress}
              paused>
              <Container className="a-left Image--lazyLoad" data-bgset={`${ShanShui}`} data-sizes="auto" langCode={langCode}>
                <Wrapper langCode={langCode}>
                  <Aside />
                  <MainContent langCode={langCode}>
                    {isChineseLang ? (
                      <FigureText className="MainHeading">
                        <BoxTitle>
                          <img src={IndependentTitle} />
                        </BoxTitle>
                      </FigureText>
                    ) : (
                      <FigureText className="MainHeading" dangerouslySetInnerHTML={{__html: miscData['independentTitle']}} />
                    )}
                    <Introduction
                      className="Paragraph"
                      langCode={langCode}
                      dangerouslySetInnerHTML={{__html: miscData['independentContent']}}
                    />
                  </MainContent>
                </Wrapper>
                <WrapperContent langCode={langCode}>
                  {isChineseLang ? (
                    <Label langCode={langCode}>
                      <Box>
                        <img src={SpiritualInspirationTitle} />
                      </Box>
                    </Label>
                  ) : (
                    <Label
                      className="MainHeading_Extra"
                      langCode={langCode}
                      dangerouslySetInnerHTML={{__html: miscData['SpiritualInspirationTitle']}}
                    />
                  )}

                  <MainContentText className="Paragraph" dangerouslySetInnerHTML={{__html: miscData['SpiritualInspirationContent']}} />
                </WrapperContent>
              </Container>
            </Tween>
          )}
        </Scene>
      </Controller>
    </>
  )
}
//
// Independent.propTypes = {
//   miscData: PropTypes.object,
//   langCode: PropTypes.string,
// }

export default Independent
